import {
  LayoutDashboard,
  UserCheck,
  Database,
  Layers,
  Heart,
  Calendar,
  Award,
  History,
  AlertTriangle,
  LineChart,
  Percent,
  Sparkles,
  Cpu,
  Search,
  Shield,
  Briefcase,
  Users,
  GitBranch,
  Target,
  Telescope,
} from 'lucide-react';

/** Sidebar entries for High-Skill Talent Retention (M13). */
export function getHighSkillRetentionNavChildren() {
  return [
    { path: '/employee-retention', label: 'Legacy retention (M8)', icon: LineChart },
    {
      path: '/high-skill-talent-retention/identify',
      label: 'Talent Identification, Profiling & Engagement',
      icon: Users,
      children: [
        { path: '/high-skill-talent-retention/dashboard', label: 'Retention Dashboard', icon: LayoutDashboard },
        { path: '/high-skill-talent-retention/critical-talent', label: 'Critical Talent Identification', icon: UserCheck },
        { path: '/high-skill-talent-retention/talent-master', label: 'High-Skill Talent Master', icon: Database },
        { path: '/high-skill-talent-retention/segmentation', label: 'Segmentation & Prioritization', icon: Layers },
        { path: '/high-skill-talent-retention/sentiment-engagement', label: 'Sentiment & Engagement Intelligence', icon: Heart },
        { path: '/high-skill-talent-retention/stay-interviews', label: 'Stay Interviews', icon: Calendar },
        { path: '/high-skill-talent-retention/recognition-rewards', label: 'Recognition & Rewards', icon: Award },
        { path: '/high-skill-talent-retention/relationship-history', label: 'Relationship History', icon: History },
      ],
    },
    {
      path: '/high-skill-talent-retention/intervention',
      label: 'Retention Strategy, Growth & Intervention',
      icon: Shield,
      children: [
        { path: '/high-skill-talent-retention/risk-assessment', label: 'Retention Risk Assessment', icon: AlertTriangle },
        { path: '/high-skill-talent-retention/attrition-prediction', label: 'Attrition Prediction & Early Warning', icon: LineChart },
        { path: '/high-skill-talent-retention/compensation-analysis', label: 'Compensation Analysis', icon: Percent },
        { path: '/high-skill-talent-retention/incentives', label: 'Retention Incentives', icon: Award },
        { path: '/high-skill-talent-retention/career-growth', label: 'Career Growth Planning', icon: Target },
        { path: '/high-skill-talent-retention/internal-mobility', label: 'Internal Mobility', icon: Briefcase },
        { path: '/high-skill-talent-retention/skill-utilization', label: 'Skill Utilization', icon: Cpu },
        { path: '/high-skill-talent-retention/criticality-mapping', label: 'Role/Project Criticality', icon: GitBranch },
        { path: '/high-skill-talent-retention/successor-coverage', label: 'Successor Coverage', icon: Users },
        { path: '/high-skill-talent-retention/development-plans', label: 'Development Plans', icon: Database },
        { path: '/high-skill-talent-retention/learning-upskilling', label: 'Learning & Upskilling', icon: Sparkles },
        { path: '/high-skill-talent-retention/workload-wellbeing', label: 'Workload & Wellbeing', icon: Heart },
        { path: '/high-skill-talent-retention/work-experience', label: 'Work Experience', icon: Heart },
        { path: '/high-skill-talent-retention/engagement-actions', label: 'Engagement Action Planning', icon: Target },
        { path: '/high-skill-talent-retention/cases', label: 'Retention Case Management', icon: Shield },
        { path: '/high-skill-talent-retention/counteroffer-handling', label: 'Offer/Counteroffer Handling', icon: AlertTriangle },
      ],
    },
    {
      path: '/high-skill-talent-retention/intelligence',
      label: 'Intelligence, Risk Prediction & Strategic Planning',
      icon: Telescope,
      children: [
        { path: '/high-skill-talent-retention/analytics', label: 'Retention Analytics', icon: LineChart },
        { path: '/high-skill-talent-retention/exit-risk-triggers', label: 'Exit Risk Triggers', icon: AlertTriangle },
        { path: '/high-skill-talent-retention/knowledge-risk', label: 'Knowledge Risk & Dependency', icon: Database },
        { path: '/high-skill-talent-retention/client-critical', label: 'Client-Critical Talent', icon: Briefcase },
        { path: '/high-skill-talent-retention/project-critical', label: 'Project-Critical Talent', icon: GitBranch },
        { path: '/high-skill-talent-retention/bench-risk', label: 'Bench Risk', icon: Users },
        { path: '/high-skill-talent-retention/promotion-stagnation', label: 'Promotion & Stagnation', icon: Target },
        { path: '/high-skill-talent-retention/forecasting', label: 'Forecasting & Stability Planning', icon: Telescope },
        { path: '/high-skill-talent-retention/ai-recommendations', label: 'AI Retention Recommendations', icon: Sparkles },
        { path: '/high-skill-talent-retention/ai-flight-risk', label: 'AI Flight Risk Prediction', icon: Cpu },
        { path: '/high-skill-talent-retention/natural-language-search', label: 'Natural Language Search', icon: Search },
        { path: '/high-skill-talent-retention/strategic-intelligence', label: 'Strategic Retention Intelligence', icon: Layers },
      ],
    },
  ];
}

